<template>
  <input-widget :model="model" :attribute="attribute"
                :label="label" :options="options" type="select2"
                display-field="${item.name}" value-field="key" :hint="hint" :items="availableLanguages"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "LanguageCodeSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        availableLanguages: state => {
          if (!state.locales || !state.locales.available_locales) {
            return []
          }
          return Object.keys(state.locales.available_locales).map(key => {
            return {
              key, name: state.locales.available_locales[key]
            }
          })
        }
      }),
    }
  }
</script>

<style scoped>

</style>
